import { format } from "date-fns";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { cpfOrCnpjMask } from "~hooks/useHelpers";
import { ArrowIcon } from "~misc/icons";
import { initialPath } from "~misc/paths";

const ListagemItem = ({ data }) => {
  const navigate = useNavigate();
  return (
    <li className="flex  justify-between bg-white px-8 py-12 mt-6 items-center rounded-lg shadow-lg hover:border-terciaria border border-solid transition-all relative">
      {data.propspect && (
        <div className="absolute top-4 left-0 bg-terciaria px-2 py-1 text-white text-xs font-bold rounded-r-md uppercase">
          Prospect
        </div>
      )}
      <div>
        {data.codigo && data.nome && (
          <h3 className="text-xl font-bold">
            {data.codigo} - {data.nome}
          </h3>
        )}
        <div className="mt-3 flex">
          <div className="mr-20">
            <p>
              CPF/CNPJ: <b className="bold">{cpfOrCnpjMask(data.documento)}</b>
            </p>
            <p>
              Segmento: <b className="bold">{data.segmento}</b>
            </p>
            <p>
              Grupo Centralizador: <b className="bold">{data.grupoCentralizador}</b>
            </p>
          </div>
          <div>
            <p>
              Data: <b className="bold">{format(new Date(data.createdAt), "dd/MM/yyyy HH:mm")}</b>
            </p>
            <p>
              Simulador: <b className="bold">{data.simulador}</b>
            </p>
          </div>
        </div>
      </div>
      <div>
        <Link to={`${initialPath}/simuladores/simulacoes/${data.clienteId}`}>
          <ArrowIcon style={{ transform: "rotate(90deg)" }} />
        </Link>
      </div>
    </li>
  );
};

export default ListagemItem;
